import React, { useImperativeHandle } from 'react';
import PropTypes from 'prop-types';

const StripeInput = React.forwardRef(({
  component: Comp,
  onFocus,
  onBlur,
  onChange,
  setInputNode,
  inputNode,
  font,
  ...other
}, ref) => {
  const props = {
    onBlur,
    onFocus,
    onChange,
    onReady: setInputNode,
    options: {
      style: {
        base: {
          fontFamily: font || 'system-ui',
          fontSize: '16px',
          color: 'black',
          '::placeholder': {
            color: '#fff',
          },
        },
        invalid: {
          color: '#ff432e',
        },
      },
    },
    ...other,
  };

  useImperativeHandle(
    ref,
    () => ({
      focus: () => {
        inputNode.focus();
      },
    }),
    [inputNode],
  );

  return <Comp {...props} />;
});

StripeInput.propTypes = {
  component: PropTypes.func.isRequired,
  onFocus: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  setInputNode: PropTypes.func.isRequired,
  inputNode: PropTypes.object,
  font: PropTypes.string,
};

export default StripeInput;
